import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ENV } from 'utils/env';
import ChoosePayment from './ChoosePayment';

const stripePromise = loadStripe(ENV.STRIPE_PUBLIC_KEY);

export const ChoosePaymentWrapper = () => {
    return (
        <Elements stripe={stripePromise}>
            <ChoosePayment />
        </Elements>
    );
};
